import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";

// Botón único que despliega avisos, notificaciones y chat (ocupa menos espacio).
export default function FabDock() {
  const [open, setOpen] = useState(false);
  const [counts, setCounts] = useState({});
  useEffect(() => {
    const h = (e) => setCounts((c) => ({ ...c, [e.detail.key]: e.detail.n }));
    const obs = new MutationObserver(() => setOpen(document.documentElement.hasAttribute("data-fab-open")));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-fab-open"] });
    window.addEventListener("zv-unread", h);
    return () => { window.removeEventListener("zv-unread", h); obs.disconnect(); document.documentElement.removeAttribute("data-fab-open"); };
  }, []);
  const toggle = () => {
    const root = document.documentElement;
    if (root.hasAttribute("data-fab-open")) root.removeAttribute("data-fab-open"); else root.setAttribute("data-fab-open", "");
  };
  const total = Object.values(counts).reduce((a, n) => a + (n || 0), 0);
  return (
    <button type="button" onClick={toggle} data-testid="fab-dock-toggle" title={open ? "Cerrar" : "Avisos y chat"}
      className="fixed right-4 bottom-28 md:bottom-4 z-[71] w-14 h-14 rounded-full bg-gradient-to-br from-navy-light to-navy text-white shadow-2xl shadow-navy/40 flex items-center justify-center active:scale-95 transition-transform">
      <Plus className={`w-7 h-7 transition-transform duration-300 ${open ? "rotate-45" : ""}`} />
      {total > 0 && !open && (
        <span data-testid="fab-dock-badge" className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center border-2 border-white">{total > 99 ? "99+" : total}</span>
      )}
    </button>
  );
}
